
import { useTranslation } from "react-i18next";


import arrowRightWLImg from '../assets/arrowRightWL.png'

const Tag = ({ color = "bg-red1 bg-opacity-20 text-red1", title }) => {
  const { t } = useTranslation();

  return (
    <div className={`${color} px-[10px] py-[6px] rounded-md text-xs font-semibold text-white`}>{title}</div>
  )
}
export default Tag